module.exports = __webpack_public_path__ + "img/vp-back.36d52a71.svg";